import { Tag } from 'antd';

export const displayName = (user, fallback = 'Team member') => {
  if (!user?.name) return fallback;
  return user.name;
};

export const initials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

export const roleTag = (role) => {
  if (role === 'admin') return <Tag color="gold">Admin</Tag>;
  if (role === 'staff') return <Tag color="blue">Staff</Tag>;
  return null;
};
